import { gql, useMutation } from "@apollo/client";

import { UpdateCategoryInput } from "../../../generated/gql/graphql";

const UPDATE_CATEGORY = gql`
  mutation UpdateCategory(
    $updateCategoryId: String!
    $input: UpdateCategoryInput!
  ) {
    updateCategory(id: $updateCategoryId, input: $input) {
      id
      name
      parentId
      orderIndex
    }
  }
`;

type UpdateCategoryApi = {
  updateCategory(id: string, input: UpdateCategoryInput): Promise<unknown>;
};

export default function useUpdateCategory(): UpdateCategoryApi {
  const [updateCategoryMut] = useMutation<UpdateCategoryInput>(UPDATE_CATEGORY);

  async function updateCategory(
    id: string,
    input: UpdateCategoryInput
  ): Promise<unknown> {
    if (!id) {
      throw new Error("Id is required");
    }

    return await updateCategoryMut({
      context: {
        headers: {
          "apollo-require-preflight": true,
        },
      },
      variables: {
        updateCategoryId: id,
        input,
      },
    });
  }

  return {
    updateCategory,
  };
}
